import { Navigate, useParams } from "react-router-dom";
import { getProjectById } from "../lib/projects";
import { getProjectUrl } from "../lib/portfolioRoutes";

/** Redirects /projects/:id to canonical /ux-portfolio/... URL for SEO */
export function ProjectRedirect(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const project = id ? getProjectById(id) : undefined;

  if (!project) {
    return <Navigate to="/404" replace />;
  }

  return <Navigate to={getProjectUrl(project)} replace />;
}
